import { entityId } from '@pkg/db/schema'

export const PatientId = entityId('patient')

export type PatientIdType = typeof PatientId.Type
